// The trick model's `terrain` field stores the user-facing label (e.g. "Rail/Jib"),
// not the backend's tag-metadata key (e.g. "rail"). The mapping is small and
// stable — encode it here rather than trying to derive it from a slug rule.
// See backend `metadata.py:get_tag_options` for the canonical keys.

const TERRAIN_TO_FEATURE: Record<string, string> = {
    "jump": "jump",
    "rail": "rail",
    "rail/jib": "rail",
    "rail jib": "rail",
    "jib": "rail",
    "halfpipe": "halfpipe",
    "half pipe": "halfpipe",
    "freeride": "freeride",
    "free ride": "freeride",
    "off-snow": "off_snow",
    "off snow": "off_snow",
    "trickshot": "trickshot",
    "trick shot": "trickshot",
};

export function terrainToFeatureKey(terrain: string | undefined | null): string {
    if (!terrain) return "";
    const key = terrain.trim().toLowerCase();
    return TERRAIN_TO_FEATURE[key] ?? key;
}

// The trick's `sport` reaches us as the user-facing label ("Snowboarding"), but
// the backend tag-metadata keys are ski / board / other — mirror the upload
// mapping in TagSelectOnUpload (`sport_api`) so the tag-options query matches.
// Already-normalized keys (ski/board/other) pass through unchanged.
const SPORT_TO_BACKEND: Record<string, string> = {
    ski: "ski",
    skiing: "ski",
    board: "board",
    snowboard: "board",
    snowboarding: "board",
};

export function sportToBackendKey(sport: string | undefined | null): string {
    if (!sport) return "";
    const key = sport.trim().toLowerCase();
    return SPORT_TO_BACKEND[key] ?? key;
}
